function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.bold.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import { commonStyles } from '../styles';
export var baseIcon = function baseIcon(props) {
  return function (theme) {
    var _theme$color;

    var color = props.color,
        onClick = props.onClick,
        size = props.size,
        filter = props.filter,
        margin = props.margin,
        padding = props.padding,
        bold = props.bold;
    return [{
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontVariant: 'normal',
      lineHeight: '1',
      textDecoration: 'inherit',
      textRendering: 'optimizeLegibility',
      textTransform: 'none',
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
      fontSmoothing: 'antialiased',
      fontSize: size !== null && size !== void 0 ? size : 24,
      fontFeatureSettings: "'liga'",
      userSelect: 'none'
    }, color && {
      color: (_theme$color = theme[color]) !== null && _theme$color !== void 0 ? _theme$color : color
    }, margin && {
      margin: "".concat(margin, " !important")
    }, padding && {
      padding: "".concat(padding, " !important")
    }, onClick && {
      cursor: 'pointer'
    }, filter && {
      filter: filter
    }, bold && {
      fontWeight: '900 !important'
    }].concat(_toConsumableArray(commonStyles(props)));
  };
};